import { render, staticRenderFns } from "./Seguridad.vue?vue&type=template&id=3dc8b2fe&"
import script from "./Seguridad.vue?vue&type=script&lang=js&"
export * from "./Seguridad.vue?vue&type=script&lang=js&"
import style0 from "./Seguridad.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports